import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { AddressesActions } from '../addressesActions';
import { CardsActions } from '../../paymentMethods/cards/cardsActions';
import AddressList from './AddressList';

function mapStateToProps(state: IReduxRootState) {
    const maxNumberOfAddress = 100;
    const { addressesMap, formOpen, loading } = state.addresses;
    const addresses = addressesMap ? Object.values(addressesMap) : [];

    return {
        maxNumberOfAddress,
        addresses,
        formOpen,
        loading,
        cardsLoading: state.cards.loading,
        cardRestrictionEnabled: state.app.appConfig.CARD_RESTRICTION_ENABLED ?? true,
        challengerPid: state.app.appConfig.CHALLENGER_PIDS.ADDRESS ?? '',
        challengerPidDefault: state.app.appConfig.CHALLENGER_PIDS.ADDRESS_DEFAULT ?? '',
        locale: state.app.locale,
    };
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
    return {
        getAddresses: () => {
            dispatch(AddressesActions.getAddresses());
        },
        getCards: () => {
            dispatch(CardsActions.getCards());
        },
        closeOverlay: () => {
            dispatch(AddressesActions.closeForm());
        },
        openOverlay: () => {
            dispatch(AddressesActions.openForm());
        },
    };
}

const AddressListContainer = connect(mapStateToProps, mapDispatchToProps)(AddressList);

export default AddressListContainer;
